<template>
    <div :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }" style="height: 100%;">
        <logo :collapse="isCollapse"/>
        <el-menu
            :default-active="activeMenu"
            :active-text-color="settings.theme"
            :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
            :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
            @open="handleOpen"
            @close="handleClose"
            :router="true"
            :unique-opened="true"
            :collapse="isCollapse"
            >
            <sidebar-item
                v-for="(route, index) in sidebarRouters"
                :key="route.path  + index"
                :item="route"
                :base-path="route.path"
            />
        </el-menu>
    </div>
</template>

<script>
    import variables from "@/assets/styles/variables.module.scss";
    import { mapGetters, mapState } from "vuex";
    import Logo from "./Logo";
    import SidebarItem from "./SidebarItem";
    export default {
        components: { Logo, SidebarItem },
        methods: {
            handleOpen(key, keyPath) {

            },
            handleClose(key, keyPath) {

            },
        },
        computed: {
            ...mapState(["settings"]),
            ...mapGetters(["sidebarRouters", "sidebar"]),
            activeMenu() {
                const route = this.$route;
                const { meta, path } = route;
                // if set path, the sidebar will highlight the path you set
                if (meta.activeMenu) {
                    return meta.activeMenu;
                }
                return path;
            },
            variables() {
                return variables;
            },
            isCollapse() {
                return !this.sidebar.opened;
            }
        }
    }
</script>